var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid"},[_c('footer',{staticClass:"mt-3 mb-1 text-blue"},[_c('div',{staticClass:"row text-white gradient rounded ml-1 mr-1"},[_c('div',{staticClass:"col text-center mb-0",staticStyle:{"font-size":"8px"}},[_vm._v(" Copyright Ponpes Baiturrahman 2025 ")])]),_c('br'),_c('br'),_c('br'),_c('br')])])
}]

export { render, staticRenderFns }